/**
 * Created by xuetao.liu on 2018/10/9.
 * @Description mounted common plugin or lib
 */
import Logic from '@/logic/logic-base'
let CallBackFn = new Logic();
import $http from '../utils/request'
import $api from './api'

export default {
    install(Vue,options){
        Vue.prototype.$http = $http;
        Vue.prototype.$http2 = CallBackFn;
        Vue.prototype.$api = $api;
    }
}


// WEBPACK FOOTER //
// ./src/libs/inject.js